import { Component, Input } from "@angular/core";

export type SharedPillStatus =
  | "neutral"
  | "info"
  | "success"
  | "warning"
  | "error";

@Component({
  selector: "app-shared-pill",
  templateUrl: "./shared-pill.component.html",
  styleUrls: ["./shared-pill.component.scss"],
  standalone: false,
})
export class SharedPillComponent {
  @Input() status: SharedPillStatus = "neutral";
}
